import { render, staticRenderFns } from "./MagicRingIcon.vue?vue&type=template&id=1558cd54&scoped=true"
import script from "./MagicRingIcon.vue?vue&type=script&lang=js"
export * from "./MagicRingIcon.vue?vue&type=script&lang=js"
import style0 from "./MagicRingIcon.vue?vue&type=style&index=0&id=1558cd54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1558cd54",
  null
  
)

export default component.exports